<script>
  export let item;
  export let diagramArrow;
</script>

<div class="diagram-item">
  <img class="diagram-item__icon" src={item.icon} alt="" />
  {#if item.rightArrow}
    <img class="diagram-item__right-arrow" src={diagramArrow} alt="" />
  {/if}
  {#if item.leftArrow}
    <img class="diagram-item__left-arrow" src={diagramArrow} alt="" />
  {/if}
  <p class="diagram-item__desc text-micro">{item.desc}</p>
</div>

<style lang="scss">
  .diagram-item {
    border: 1px dotted $light-border;
    border-radius: 10px;
    padding: 4rem 2rem;
    width: 13.5rem;
    position: relative;
    flex-grow: 0;
    flex-shrink: 0;
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: url(img/noise.png) 300px 300px;
      opacity: 0.2;
      border-radius: 10px;
    }

    &__icon {
    }

    &__right-arrow {
      position: absolute;
      top: 5.6rem;
      right: -2rem;
    }

    &__left-arrow {
      position: absolute;
      top: 7.2rem;
      right: -3.5rem;
      transform: rotate(180deg);
    }

    &__desc {
      margin-top: 1.5rem;
    }
  }
</style>
